import { Modal } from 'antd';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/AccessControlEmployer/AccessControlEmployerModel';
import { RootState } from '../../../store';
import AccessControlEmployerForm from '../AccessControlEmployerForm/AccessControlEmployerForm';

const AccessControlEmployerModal: FC<any> = () => {
  const dispatch = useDispatch();
  const reduxAccessControlEmployer = useSelector((state: RootState) => state.models.accessControlEmployer);

  return (
    <Modal
      title={!!reduxAccessControlEmployer.id ? 'Modifica' : 'Adauga'}
      open={reduxAccessControlEmployer.props.isModalVisible}
      onCancel={() => dispatch(updateProps({ field: 'isModalVisible', value: false }))}
      width={700}
      footer={null}
    >
      <AccessControlEmployerForm />
    </Modal>
  );
};

export default AccessControlEmployerModal;
